import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientCareProviders = (state, patientId) =>
  allModelsSelector(state, 'PatientCareProvider', (p) => p.patientId === patientId);
